import { FLEX_PRODUCTS } from "pages/FlexSetup/constants";

function useProduct({ products }) {
  const productList = Object.keys(products);
  const productNames = FLEX_PRODUCTS.filter((product) =>
    productList.includes(product.value)
  ).map((product) => ({
    display_name: product.display_name,
    value: product.value,
  }));

  return { productNames };
}

export default useProduct;
